import React from "react";

/**
 * Tilted sticker pill. <Pill color="#c8ff2a">Casual</Pill>
 */
const Pill = ({ children, color = "#c8ff2a", tilt = 0, className = "" }) => (
  <span
    className={`inline-flex items-center gap-1 px-3 py-1.5 font-black text-[11px] tracking-[0.28em] uppercase border-2 ${className}`}
    style={{
      borderColor: color,
      color,
      background: "rgba(6,6,6,0.5)",
      borderRadius: "999px",
      transform: `rotate(${tilt}deg)`,
      whiteSpace: "nowrap",
    }}
  >
    {children}
  </span>
);

export default Pill;
